//我的api
import request from "@/utils/request";

export const url = {
  my_ChangePassword: "/api/GroupUser/ChangePassword",
  my_Get: "/api/User/Get",
  my_UserChangePassword: "api/User/ChangePassword",
  EnumDesc_GetList: "/api/Common/GetEnumDesc", //获取枚举接口
  User_Info: "/api/User/Get",
  User_EditWechatSetting: "/api/User/EditWechatSetting", //选择接收微信消息的类别
};

export function SetChangePassword(data) {
  return request({
    url: url.my_ChangePassword,
    method: "post",
    data: data,
  });
}
export function GetEnumDesc(data) {
  return request({
    url: url.EnumDesc_GetList,
    method: "post",
    data: data,
  });
}
export function GetUserInfo(data) {
  return request({
    url: url.User_Info,
    method: "post",
    data: data,
  });
}
export function EditWechatSetting(data) {
  return request({
    url: url.User_EditWechatSetting,
    method: "post",
    data: data,
  });
}
export function GetUser(data) {
  return request({
    url: url.my_Get,
    method: "post",
    data: data,
  });
}

export function SetUserChangePassword(data) {
  return request({
    url: url.my_UserChangePassword,
    method: "post",
    data: data,
  });
}
